import React from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link, Stack} from '@customink/pigment-react';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function UploadFileUnsupportedError(props) {
  const {dismiss} = props;
  return (
    <Notification
      {...props}
      title={
        <span>
          <span>Oops!</span> <span>Your file is an unsupported file type.</span>
        </span>
      }>
      <p>
        Accepted file types (max size: 5 MB): .JPG .JPEG .PNG .GIF .BMP .PDF .AI
        .PSD .EPS .WEBP .TIF .TIFF
      </p>
      <p>
        Have a different type of file?{' '}
        <span>
          <Link href="#/help" onClick={dismiss}>
            Email it to us
          </Link>
        </span>{' '}
        and weʼll have it ready for you to use within a few hours!
      </p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={dismiss}>
          Close
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

UploadFileUnsupportedError.propTypes = propTypes;

UploadFileUnsupportedError.displayName = 'UploadFileUnsupportedError';
